import React from 'react';
import { Container, Box, Image } from '../../Styles/HomeStyle';

const Home = () => {
  return (
    <React.Fragment>
      <Container>
        <Image src='/images/promatec.png' />
        <Box></Box>
      </Container>
    </React.Fragment>
  );
};

export default Home;
